import dayjs from "dayjs";
const AYANT_DROIT_OPTION_NONE = {'label': 'Non', 'value': '0'};
const AYANT_DROIT_OPTION_MAIN = {'label': 'Assuré principal', 'value': 'internaute'};
const AYANT_DROIT_OPTION_SPOUSE = {'label': 'Conjoint', 'value': 'conjoint'};

const ayantDroitOptionsFn = (dateEffetInDDMMYYYY, dateDeNaissanceInDDMMYYYY, displayConjoint) => {
    const ayantDroitOptions = []
    const dateEffet = dayjs(dateEffetInDDMMYYYY, 'DD/MM/YYYY')
    const dateDeNaissance = dayjs(dateDeNaissanceInDDMMYYYY, 'DD/MM/YYYY')

    if (dateDeNaissance.add(16, 'years') < dateEffet) {
        ayantDroitOptions.push(AYANT_DROIT_OPTION_NONE)
    }

    ayantDroitOptions.push(AYANT_DROIT_OPTION_MAIN);

    if (displayConjoint) {
        ayantDroitOptions.push(AYANT_DROIT_OPTION_SPOUSE)
    }

    return ayantDroitOptions;
}

export {
    ayantDroitOptionsFn
}
